import React from 'react';
import Helper from './Helper';

class FormReplyComment extends React.Component {
    handleShowReply=(isShowReply)=>{
        this.props.handleShowReply(isShowReply);
    }
    handleReply=(event)=>{
        event.preventDefault();
        const data = new FormData(event.target);
        data.set('product_id', this.props.product.info.product_id);
        data.set('alias', this.props.product.info.alias);
        data.set('member_id', this.props.account.id);
        data.set('reply_to', this.props.replyTo);
        data.set('level', 1);

        fetch(Helper.getSiteUrl() + '/post/SubmitReview', {
            method: 'POST',
            body: data,
        }).then(res => res.text()).then(
            (result)=>{
                result = JSON.parse(result);
                result.response === 'success' && 
                window.location.reload();
            }
        );
    }
    render(){
        let {review, account} = this.props;
        if(!account)
        {
            return <div className="alert-component">Vui lòng đăng nhập</div>
        }
        let inputName = account.review_name ? 
        <select className="form-control form-control-sm input-reply" name="input_name" 
        defaultValue={account.review_name}>
            <option value={account.review_name}>{account.review_name}</option>
            <option value={account.name}>{account.name}</option>
        </select>:
        <input className="form-control form-control-sm input-reply" required name="input_name" 
        defaultValue={account.name} placeholder="Tên hiển thị" />
        return (
            <div className="form-reply-comment m-0 p-2 bg-dark">
                <form onSubmit={(e)=>this.handleReply(e)}>
                    <div className="form-group">
                        <label>Tiêu đề</label>
                        <input type="text" required defaultValue={`Re: ${review.title}`}
                        className="form-control form-control-sm input-reply" name="title"/>
                    </div>
                    <div className="form-group">
                        <label>Tên hiển thị</label>
                        {inputName}
                    </div>
                    <div className="form-group">
                        <label>Nội dung</label>
                        <textarea className="form-control form-control-sm input-reply" name="content" 
                        placeholder="Nội dung" rows="4"></textarea>
                    </div>
                    
                    <div className="form-group input-group d-flex justify-content-end">
                        <div className="input-group-prepend">
                            <button onClick={()=>this.handleShowReply(false)} className="btn btn-default" type="button"><i className="fas fa-times" /> Đóng</button>
                        </div>
                        <button className="btn btn-danger" type="submit">Trả lời</button>
                    </div>
                </form>
            </div>
        )
    }
}
export default FormReplyComment;